import React from 'react';
import HomeschoolSection3 from './HomeschoolSection3';
import HomeschoolSection4 from './HomeschoolSection4';
import HomeschoolSection5 from './HomeschoolSection5';
import HomeschoolSection6 from './HomeschoolSection6';
import HomeschoolSection7 from './HomeschoolSection7';
import HomeschoolSection8 from './HomeschoolSection8';
import HomeschoolSection9 from './HomeschoolSection9';
import HomeschoolSection10 from './HomeschoolSection10';
import HomeschoolSection11 from './HomeschoolSection11';
import { isWithin } from '../../../api/utils/util-func';
import HomeschoolCostEffective from './HomeschoolCostEffective';
import { HomeschoolPriceProvider } from './HomeschoolPriceContext';
import HomeschoolEvent202601 from './event/HomeschoolEvent202601';
import HomeschoolEvent202602 from './event/HomeschoolEvent202602';

const HomeschoolMain = () => {
  return (
    <HomeschoolPriceProvider>
      <div>
        {/* 월별 프로모션 섹션 */}
        {isWithin('2026-01-01', '2026-01-31') ? (
          <HomeschoolEvent202601 />
        ) : (
          <HomeschoolEvent202602 />
        )}

        {/* {isWithin('2025-08-01', '2025-08-31') ? <HomeschoolEvent202508 /> : null} */}

        {/* <HomeschoolSection1 /> */}
        {/* <HomeschoolSection2 /> */}

        {/* 영어교육의 해답, 왜 젭스영어교실에 있을까? */}
        <HomeschoolSection3 />

        {/* 영어교실 연령별 맞춤코스, 이렇게 구성되어 있어요! */}
        <HomeschoolSection4 />

        {/* 젭스영어성경홈스쿨 코스 TIP */}
        <HomeschoolSection5 />

        {/* 젭스홈스쿨 패키지 코스 구성 */}
        <HomeschoolSection6 />

        {/* 아무리 비교해 봐도 이런 가성비는 없습니다! */}
        <HomeschoolCostEffective />

        {/* 젭스영어성경홈스쿨, 이렇게 시작하세요! */}
        <HomeschoolSection7 />

        {/* 홈스쿨 운영 절차 */}
        <HomeschoolSection8 />

        {/* 회원에게만 주어지는 풍성한 혜택! */}
        <HomeschoolSection9 />

        {/* 링크 */}
        <HomeschoolSection10 />

        {/* FAQ */}
        <HomeschoolSection11 />
      </div>
    </HomeschoolPriceProvider>
  );
};

export default HomeschoolMain;
